<template>
  <div class="m-footer">
    <div class="sns">
      <a href="https://t.me/+43PRCVEduUw0NGJk"><img src="@/assets/img/ico/telegram-icon.png"> <span style="margin-left: 5px;">공지방</span></a>
      <router-link to="/bbs/c/l"><img src="@/assets/img/ico/telegram-icon1.png"> <span style="margin-left: 5px;">고객센터</span></router-link>
      <a href="javascript:void(0)" @click="clearCacheAndLogout" class="cache-clear-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
        <span style="margin-left: 5px;">캐시삭제</span>
      </a>
    </div>
    <div class="t1"><img src="@/assets/img/etc/footer_partner.jpg"></div>
    <div class="logos">
      <table>
              <tr>
                <td style="text-align: center; width: 122px">
                  <a href="https://pu-11.com/" style="margin-left: auto; margin-right:auto;">
                    <img src="@/assets/img/main/vikbet_logo_main.png" alt="1" style="height: 30px;">
                  </a>
                </td>
                <td style="text-align: center; width: 122px">
                  <a href="https://ka-11.com/">
                    <img src="@/assets/img/main/kai_logo_main.png" alt="2" style="height: 30px;">
                  </a>
                </td>
                <td style="text-align: center; width: 122px">
                  <a href="https://luna-11.com/">
                    <img src="@/assets/img/main/luna_logo_main.png" alt="3" style="height: 30px;">
                  </a>
                </td>
              </tr>
              <tr style="height: 20px;"></tr>
              <!-- <tr>
                <td>
                  <img src="@/assets/img/footer/4.jpg" alt="4">
                </td>
                <td>
                  <img src="@/assets/img/footer/5.jpg" alt="5">
                </td>
                <td>
                  <img src="@/assets/img/footer/6.jpg" alt="6">
                </td>
              </tr> -->
              <!-- <tr>
                <td style="text-align: center;" colspan="3">
                  <a href="https://www.vkingbet.com/ko">
                    <img src="@/assets/img/main/바이킹 로고.png" alt="3" style="height: 30px;">
                  </a>
                </td>
              </tr> -->
            </table>
    </div>

    <div class="foot-txt">
      Gambling can be addictive. Play responsibly.<br>
      vwww.gamblingtherapy.org &amp; www.gamblersanonymous.org<br><br>
      ALL RIGHTS RESERVED. | +18
    </div>


    <div class="logo"><img src="@/assets/img/main/kiki_logo_main.png" style="height: 40px;"></div>
    <!-- <div class="logo"><img src="@/assets/img/main/kiki 모바일버전.png" style="height: 40px;"></div> -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    movePage: function(page){
      this.$router.push({path: `/${page}`})
    },
    clearCacheAndLogout() {
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(';').forEach(c => {
        document.cookie = c.trim().split('=')[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      });
      if ('caches' in window) {
        caches.keys().then(names => names.forEach(name => caches.delete(name)));
      }
      window.location.href = '/main';
    },
  }
}
</script>

<style scoped>

</style>
